import { render } from "./a-fumbi-advantages.vue?vue&type=template&id=aca4c380&scoped=true"
import script from "./a-fumbi-advantages.vue?vue&type=script&lang=js"
export * from "./a-fumbi-advantages.vue?vue&type=script&lang=js"

import "./a-fumbi-advantages.vue?vue&type=style&index=0&id=aca4c380&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca4c380"]])

export default __exports__